import React from "react";
import { Button, Typography, Box, Icon } from "@mui/material";
import { Link } from "react-router-dom";
import PageLayout from "@/components/layouts/page/PageLayout";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const CustomizeAds = ({ campaign_id, is_redirect }) => {
  const getButtonLink = () => {
    if (is_redirect && campaign_id) {
      return `/participant/join-campaign/${campaign_id}`;
    }
    return `/launch-digital-campaigns`;
  };

  return (
    <PageLayout className="customize-ads-container mx-0 mx-sm-2">
      <Box
        className="customize-ads-page"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
      >
        <Icon
          component={RpSvgIcon}
          name="success_icon"
          color="primary"
          size="large"
          style={{ fontSize: "8.5rem" }}
        />
        <Typography color="text.primary" variant="h4" className="fw-b">
          All Set!
        </Typography>
        <Typography className="heading12 w-75 fw-sb px-md-5 text-center description mt-2">
          You can now select a preferred message for your locations
        </Typography>
        <Box className="d-flex-center my-5">
          <Button
            component={Link}
            to={getButtonLink()}
            className="customized-ads-btn"
            variant="contained"
            color="primary"
            size="large"
            replace
          >
            Customize Ads
          </Button>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default CustomizeAds;
